import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/material/styles';
import { Title } from 'components';
import Typography from '@mui/material/Typography';

const VictimCardTitle = ({ title, children }) => {
  const theme = useTheme();

  return (
    <div style={{ display: 'flex', alignItems: 'center', width: '100%', marginBottom: '5px' }}>
      
      {/* Left line - fixed 100px */}
      <div style={{
        width: 100,
        height: 2,
        background: `linear-gradient(80deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.dark} 60%)`,
        borderRadius: 2,
      }} />

      {/* Text */}
      <div style={{
        color: 'purple',
        fontSize: '12px',
        margin: '0 10px',
        whiteSpace: 'nowrap',
      }}>
        <Typography
          variant="h1"
          //fontWeight={700}
          fontSize={'16px'}
          fontFamily={theme.typography?.h1_fontFamily}
          //gutterBottom
          sx={{ mb: '1px', color: theme.palette.text.primary }}
          className="font-semibold"
        >
        {title || children}
      </Typography>
      </div>

      {/* Right line - flexible */}
      <div style={{
        flex: 1,
        height: 2,
        background: `linear-gradient(80deg, ${theme.palette.primary.main} 30%, ${theme.palette.primary.dark} 60%)`,
        borderRadius: 2,
      }} />
    </div>
  );
};

VictimCardTitle.propTypes = {
  title: PropTypes.node,
  children: PropTypes.node,
};

export default VictimCardTitle;
